import client from '@config/client'
import API_URL from '@config/services'
import { ApiClientResult } from '@/types/api'

interface TicketPayload {
  title?: string
  description?: string
  priority?: string
  status?: string
  [key: string]: any
}

interface TicketActionPayload {
  action?: string
  comment?: string
  [key: string]: any
}

/**
 * Creates a new ticket
 * @param payload - Ticket data
 * @returns API response
 */
export const onCreateTicket = (
  payload: TicketPayload
): Promise<ApiClientResult> => {
  return client
    .post(API_URL.TICKETS.POST_TICKET(), payload)
    .then(response => response)
    .catch(error => {
      return error.response
    })
}

/**
 * Deletes a ticket
 * @param ticketId - Ticket ID
 * @returns API response
 */
export const onDeleteTicket = (
  ticketId: number | string
): Promise<ApiClientResult> => {
  return client
    .delete(API_URL.TICKETS.DELETE_TICKET(ticketId))
    .then(response => response)
    .catch(error => {
      return error.response
    })
}

/**
 * Updates a ticket
 * @param ticketId - Ticket ID
 * @param payload - Ticket data to update
 * @returns API response
 */
export const onUpdateTicket = (
  ticketId: number | string,
  payload: TicketPayload
): Promise<ApiClientResult> => {
  return client
    .patch(API_URL.TICKETS.PATCH_TICKET(ticketId), payload)
    .then(response => response)
    .catch(error => {
      return error.response
    })
}

/**
 * Gets a ticket by ID
 * @param ticketId - Ticket ID
 * @returns API response
 */
export const onGetTicket = (
  ticketId: number | string
): Promise<ApiClientResult> => {
  return client
    .get(API_URL.TICKETS.GET_TICKET(ticketId))
    .then(response => response)
    .catch(error => {
      return error.response
    })
}

/**
 * Gets all tickets
 * @returns API response
 */
export const onGetAllTickets = (): Promise<ApiClientResult> => {
  return client
    .get(API_URL.TICKETS.GET_TICKETS())
    .then(response => response)
    .catch(error => {
      return error.response
    })
}

/**
 * Performs an action on tickets
 * @param orgPk - Organization ID
 * @param payload - Action data
 * @returns API response
 */
export const postTicketsAction = (
  orgPk: number | string,
  payload: TicketActionPayload
): Promise<ApiClientResult> => {
  return client
    .post(API_URL.TICKETS.POST_TICKETS_ACTION(orgPk), payload)
    .then(response => response)
    .catch(error => {
      return error.response
    })
}
